import { RouterLink } from "../../../../../../components/router-link";

interface Props {
  verificationCodeId: string;
  label: string;
}

export const VerificationCodeLinkCell = ({ verificationCodeId, label }: Props) => {
  return (
    <RouterLink params={{ verificationCodeId }} to={"/app/verification-codes/$verificationCodeId"} underline="hover">
      {label}
    </RouterLink>
  );
};
